import { Injectable } from '@angular/core';
import { SessionService } from './session.service';
import { BooxService } from './boox.service';
import { IStringAnyMap } from '../app.types';
import { BehaviorSubject, fromEvent, map, Observable, tap } from 'rxjs';
import * as _ from 'lodash';
import { environment } from 'src/environments/environment';

export interface IAppEnvironment extends IStringAnyMap {
  apps : IStringAnyMap[],
  features : {
    IMPERSONATE : boolean,
  },
}

@Injectable({
  providedIn: 'root'
})
export class AppService {

  // public $message : Observable<MessageEvent>;

  public $environment : BehaviorSubject<IAppEnvironment|null> = new BehaviorSubject<IAppEnvironment|null>(null);

  public get environment() : IAppEnvironment|null {
    return this.$environment.getValue();
  }

  public $apps : Observable<IStringAnyMap[]|null> = this.$environment.pipe(map((_environment : IAppEnvironment| null) => _environment?.apps || null));

  public get apps() : IStringAnyMap[] {
    return this.environment?.apps || [];
  }

  public $features : Observable<IStringAnyMap> = this.$environment.pipe(map((_environment : IAppEnvironment| null) => _environment?.features || {}));

  public get features() : IStringAnyMap {
    return this.environment?.features || {};
  }

  constructor(
    private session : SessionService,
    private boox : BooxService,
  ) { 

    // this.$message = fromEvent<MessageEvent>(window, 'message').pipe(tap((_e) => console.log('HOST HostService', 'constructor', _e)));
    
    // this.getFilteredMessages('*', 'app.client.ready').subscribe((_e) => {
    //   console.log('HOST HostService', 'registerHostEvents', {..._e.data});
    // });

    // subscribe to session valid changes and reload environment
    this.session.$valid.subscribe((_session) => {

      if(!_session) {
        this.$environment.next(null);
        return;
      }
      
      this.boox
          .get<IAppEnvironment>('system/environment')
          .subscribe((_response : IAppEnvironment) => {
            // Dev-only: inject People until backend lists it in system/environment
            if(!environment.production && !_response.apps?.find((_a : IStringAnyMap) => _a['path'] === '/app/people')) {
              _response.apps = [..._response.apps, {
                id: 999,
                name: 'KETCH<span>PEOPLE</span>',
                description: '',
                url: '',
                path: '/app/people',
                is_external: false,
                is_default: false,
                allow_fullscreen_toggle: true,
                requires_fullscreen: false,
                toggle_location: 'top',
              }];
            }
            this.$environment.next(_response);
          });
    });

  }

  // Send a message to the target window
  // public postMessage(targetWindow: Window, message: IStringAnyMap): void {
  //   console.log('HOST postMessage', targetWindow, message);
  //   targetWindow.postMessage(message, '*');
  // }

  // Filter messages by origin or type
  // public getFilteredMessages(origin: string, type?: string): Observable<any> {
  //   return this.$message.pipe(
  //     // tap((_e) => console.log('HostService', 'getFilteredMessages', _e)),
  //     // filter(event => event.origin === origin), // Verify origin
  //     // map(event => {
  //     //   // Optionally filter by message type
  //     //   if (type && event.data.type !== type) {
  //     //     return null;
  //     //   }
  //     //   return event.data;
  //     // }),
  //     // filter(data => data !== null) // Remove nulls if filtering by type
  //   );
  // }

}
